<template>
  <VisaForm country="morocco" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products="products" />
      <EntryFields v-model="form.entry" :date-hint="$tt('estimate_entry_in_half_year')" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>
    
    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
          <OccupationStatus v-model="applicant.occupation" />
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>